(() => {
  const initialize = (builder) => {
    if (builder.dataset.ttInitialized === 'true') return;
    builder.dataset.ttInitialized = 'true';
    const detailsDialog = builder.querySelector('[data-tt-details-dialog]');
    if (detailsDialog && typeof detailsDialog.showModal === 'function') {
      let detailsOpener = null;
      let previousOverflow = '';
      const closeDetails = () => detailsDialog.close();
      builder.querySelectorAll('[data-tt-details]').forEach((link) => link.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const card = link.closest('[data-tt-product-card]');
        const content = card?.querySelector('[data-tt-details-content]');
        if (!content || detailsDialog.open) return;
        event.preventDefault();
        event.stopPropagation();
        detailsOpener = link;
        detailsDialog.querySelector('[data-tt-details-title]').textContent = card.dataset.productTitle;
        const body = detailsDialog.querySelector('[data-tt-details-body]');
        body.replaceChildren(content.content.cloneNode(true));
        // Start with the color currently shown on the card without changing kit state.
        const variantImage = card.dataset.productImage;
        const gallery = body.querySelector('.tt-product-details__gallery');
        if (variantImage && gallery) {
          const image = document.createElement('img');
          image.src = variantImage;
          image.alt = card.dataset.productTitle;
          image.loading = 'eager';
          const matchingImage = [...gallery.querySelectorAll('img')].find((photo) => {
            return new URL(photo.src, location.href).pathname === new URL(variantImage, location.href).pathname;
          });
          matchingImage?.remove();
          gallery.prepend(image);
        }
        if (gallery) {
          const photos = [...gallery.querySelectorAll('img')];
          const mainPhoto = photos[0];
          if (mainPhoto) {
            mainPhoto.className = 'tt-product-details__main-photo';
            const thumbnails = document.createElement('div');
            thumbnails.className = 'tt-product-details__thumbnails';
            photos.forEach((photo, index) => {
              const button = document.createElement('button');
              button.type = 'button';
              button.setAttribute('aria-label', `View photo ${index + 1} of ${card.dataset.productTitle}`);
              button.setAttribute('aria-pressed', String(index === 0));
              button.append(photo.cloneNode(true));
              button.addEventListener('click', () => {
                mainPhoto.src = photo.src;
                mainPhoto.alt = photo.alt;
                [...thumbnails.children].forEach((thumbnail) => thumbnail.setAttribute('aria-pressed', String(thumbnail === button)));
              });
              thumbnails.append(button);
            });
            gallery.replaceChildren(mainPhoto);
            if (photos.length > 1) gallery.append(thumbnails);
          }
        }
        previousOverflow = document.body.style.overflow;
        detailsDialog.showModal();
        document.body.style.overflow = 'hidden';
        detailsDialog.scrollTop = 0;
      }));
      detailsDialog.querySelectorAll('[data-tt-details-close]').forEach((button) => button.addEventListener('click', closeDetails));
      detailsDialog.addEventListener('click', (event) => {
        if (event.target !== detailsDialog) return;
        const rect = detailsDialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDetails();
      });
      detailsDialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        detailsOpener?.focus({ preventScroll: true });
        detailsDialog.querySelector('[data-tt-details-body]').replaceChildren();
      });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(builder) && detailsDialog.open) closeDetails();
      });
    }
    const cards = [...builder.querySelectorAll('[data-tt-product-card]')];
    const checkout = builder.querySelector('[data-tt-checkout]');
    const status = builder.querySelector('[data-tt-status]');
    const error = builder.querySelector('[data-tt-error]');
    const summary = builder.querySelector('[data-tt-summary]');
    const selections = builder.querySelector('[data-tt-selections]');
    const subtotal = builder.querySelector('[data-tt-subtotal]');
    const total = builder.querySelector('[data-tt-total]');
    const estimatedDiscount = builder.querySelector('[data-tt-estimated-discount]');
    const discountLabel = builder.querySelector('[data-tt-discount-label]');
    const discountHelp = builder.querySelector('[data-tt-discount-help]');
    const discountRequirements = builder.querySelector('[data-tt-discount-requirements]');
    const discountRequirementsList = builder.querySelector('[data-tt-discount-requirements-list]');
    const estimatedDiscountAmount = builder.querySelector('[data-tt-estimated-discount-amount]');
    const estimatedTotal = builder.querySelector('[data-tt-estimated-total]');
    const estimatedTotalAmount = builder.querySelector('[data-tt-estimated-total-amount]');
    const summaryToggle = builder.querySelector('[data-tt-summary-toggle]');
    const summaryPanel = builder.querySelector('[data-tt-summary-panel]');
    const reviewCart = builder.querySelector('[data-tt-review-cart]');
    const topperToggle = builder.querySelector('[data-tt-topper-toggle]');
    const topperCards = cards.filter((card) => card.dataset.kind === 'topper');
    const topperFilters = [...builder.querySelectorAll('[data-tt-topper-filter]')];
    const configuredTopperMinimum = Number(summary.dataset.topperLimit || 2);
    const topperMinimum = Number.isInteger(configuredTopperMinimum) && configuredTopperMinimum > 0 ? configuredTopperMinimum : 2;
    const topperLabel = (count) => count === 1 ? 'Topper' : 'Toppers';
    const lockPreselectedToppers = summary.dataset.lockPreselectedToppers === 'true';
    const preselectedHat = cards.find((card) => card.dataset.kind === 'hat' && card.dataset.preselectedHat === 'true' && !card.querySelector('[data-tt-select]')?.disabled);
    const lockedHat = summary.dataset.lockPreselectedHat === 'true' ? preselectedHat : null;
    const lockedToppers = new Set(lockPreselectedToppers
      ? topperCards.filter((card) => card.dataset.preselectedTopper === 'true')
      : []);
    let activeTopperFilter = topperFilters[0]?.dataset.ttTopperFilter || 'all';
    let toppersExpanded = false;

    const syncTopperDisplay = () => {
      const matchingCards = topperCards.filter((card) => activeTopperFilter === 'all' || (card.dataset.ttTopperCollections || '').includes(`|${activeTopperFilter}|`));
      topperCards.forEach((card) => {
        const matchIndex = matchingCards.indexOf(card);
        card.hidden = matchIndex === -1 || (!toppersExpanded && matchIndex >= 8);
      });
      if (topperToggle) {
        topperToggle.hidden = matchingCards.length <= 8;
        topperToggle.setAttribute('aria-expanded', String(toppersExpanded));
        topperToggle.textContent = toppersExpanded ? 'See less' : 'See more';
      }
    };

    topperFilters.forEach((filter) => filter.addEventListener('click', () => {
      activeTopperFilter = filter.dataset.ttTopperFilter;
      toppersExpanded = false;
      topperFilters.forEach((button) => {
        const active = button === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      syncTopperDisplay();
    }));

    syncTopperDisplay();

    const selected = { hat: null, toppers: [] };
    let submitting = false;
    let bundleId = null;

    const variantData = (card) => {
      const input = card.querySelector('[data-tt-variant]:checked') || card.querySelector('[data-tt-variant]');
      const option = input;
      return {
        id: Number(input.value),
        title: option.dataset.variantTitle || '',
        price: Number(option.dataset.price || 0),
        image: option.dataset.image || card.dataset.productImage || ''
      };
    };

    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: summary.dataset.currency || 'USD' }).format(cents / 100);

    const estimatedDiscountCents = (subtotalCents) => {
      if (!summary.dataset.couponCode.trim()) return 0;
      const type = summary.dataset.estimatedDiscountType;
      const value = Number(summary.dataset.estimatedDiscountValue || 0);
      if (!Number.isFinite(value) || value <= 0) return 0;
      if (type === 'percentage') return Math.min(subtotalCents, Math.round(subtotalCents * value / 100));
      if (type === 'fixed_amount') return Math.min(subtotalCents, Math.round(value * 100));
      return 0;
    };

    const createBundleId = () => window.crypto?.randomUUID?.() || `tt-${Date.now()}-${Math.random().toString(16).slice(2)}`;

    const applyCampaignCoupon = async () => {
      const coupon = summary.dataset.couponCode.trim();
      if (!coupon) return { requested: false, succeeded: true };
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: coupon, sections: ['cart-drawer'] })
        });
        if (!response.ok) return { requested: true, succeeded: false };
        const cart = await response.json();
        const normalizedCoupon = coupon.toLowerCase();
        const appliedDiscountTitles = [
          ...(cart.cart_level_discount_applications || []).map((application) => application.title),
          ...(cart.items || []).flatMap((item) => (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application?.title))
        ].filter(Boolean);
        const succeeded = appliedDiscountTitles.some((title) => title.toLowerCase() === normalizedCoupon);
        updateRenderedCart(cart);
        return { requested: true, succeeded };
      } catch {
        return { requested: true, succeeded: false };
      }
    };

    const finishAdd = async () => {
      const coupon = await applyCampaignCoupon();
      selected.hat = lockedHat;
      selected.toppers = [...lockedToppers];
      cards.forEach((card) => setCardState(card, card === lockedHat || (card.dataset.kind === 'topper' && lockedToppers.has(card))));
      update();
      submitting = false;
      bundleId = null;
      checkout.textContent = 'Add to cart';
      reviewCart.textContent = 'View cart';
      reviewCart.hidden = false;
      status.textContent = coupon.requested
        ? coupon.succeeded
          ? 'Starter kit added to cart. The campaign coupon will apply if eligible.'
          : 'Starter kit added to cart, but the campaign coupon could not be applied.'
        : 'Starter kit added to cart.';
    };

    const bundleState = (cartItems, id, expectedTopperCount) => {
      const matching = (cartItems || []).filter((item) => item.properties?.['_Starter Kit ID'] === id);
      const roles = new Set(matching.map((item) => item.properties?.['_Starter Kit Role']));
      const quantity = matching.reduce((sum, item) => sum + item.quantity, 0);
      const expectedQuantity = expectedTopperCount + 1;
      const completeRoles = roles.size === expectedQuantity && roles.has('hat') && Array.from({ length: expectedTopperCount }, (_, index) => roles.has(`topper-${index + 1}`)).every(Boolean);
      return { complete: matching.length === expectedQuantity && quantity === expectedQuantity && completeRoles, partial: matching.length > 0 };
    };

    const reconcileBundle = async (id, expectedTopperCount) => {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Cart verification failed.');
      const cart = await response.json();
      return bundleState(cart.items, id, expectedTopperCount);
    };

    const reconcileBundleWithRetry = async (id, expectedTopperCount) => {
      const delays = [150, 350, 700];
      let lastState = { complete: false, partial: false };
      for (const delay of delays) {
        await new Promise((resolve) => setTimeout(resolve, delay));
        lastState = await reconcileBundle(id, expectedTopperCount);
        if (lastState.complete || lastState.partial) return lastState;
      }
      return lastState;
    };

    const updateRenderedCart = (result) => {
      if (Number.isInteger(result.item_count)) {
        document.querySelectorAll('.header-cart__count').forEach((count) => {
          count.textContent = String(result.item_count);
        });
      }
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || !result.sections || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.getSectionInnerHTML !== 'function') return;
      drawer.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        const sectionHtml = result.sections[section.id];
        if (!sectionElement || !sectionHtml) return;
        sectionElement.innerHTML = drawer.getSectionInnerHTML(sectionHtml, section.selector);
      });
      const drawerHtml = result.sections['cart-drawer'];
      if (drawerHtml) drawer.classList.remove('is-empty');
    };

    topperToggle?.addEventListener('click', () => {
      toppersExpanded = !toppersExpanded;
      syncTopperDisplay();
      if (!toppersExpanded) topperToggle.scrollIntoView({ block: 'nearest' });
    });

    reviewCart?.addEventListener('click', async (event) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      event.stopPropagation();
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`, {
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Cart drawer refresh failed.');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const sourceDrawer = html.querySelector('cart-drawer');
        if (!sourceDrawer) throw new Error('Cart drawer markup was unavailable.');
        for (const selector of ['cart-drawer-items', '.cart-drawer__footer']) {
          const source = sourceDrawer.querySelector(selector);
          const target = drawer.querySelector(selector);
          if (source && target) target.replaceWith(source);
        }
        drawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
        drawer.open(reviewCart);
      } catch {
        window.location.assign(reviewCart.href);
      }
    });

    const setSummaryExpanded = (expanded) => {
      summaryToggle.setAttribute('aria-expanded', String(expanded));
      summaryToggle.querySelector('[data-tt-toggle-label]').textContent = expanded ? 'Hide details' : 'Show details';
      summaryPanel.hidden = !expanded;
    };

    const summaryTrigger = builder.querySelector('[data-tt-summary-trigger]');
    const initialScrollY = window.scrollY;
    let summaryFrame = 0;
    const stopSummaryExpansion = () => {
      window.removeEventListener('scroll', onSummaryScroll);
      cancelAnimationFrame(summaryFrame);
    };
    const onSummaryScroll = () => {
      cancelAnimationFrame(summaryFrame);
      summaryFrame = requestAnimationFrame(() => {
        if (window.scrollY <= initialScrollY || !summaryTrigger) return;
        if (summaryTrigger.getBoundingClientRect().top >= window.innerHeight) return;
        setSummaryExpanded(true);
        stopSummaryExpansion();
      });
    };
    summaryToggle?.addEventListener('click', () => {
      stopSummaryExpansion();
      setSummaryExpanded(summaryToggle.getAttribute('aria-expanded') !== 'true');
    });
    if (summaryToggle && summaryPanel && summaryTrigger) {
      window.addEventListener('scroll', onSummaryScroll, { passive: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(builder)) stopSummaryExpansion();
      });
    }

    const setCardState = (card, active) => {
      card.classList.toggle('is-selected', active);
      const button = card.querySelector('[data-tt-select]');
      button.setAttribute('aria-pressed', String(active));
      button.querySelector('[data-tt-select-label]').textContent = lockedHat === card || lockedToppers.has(card) ? 'Included' : active ? 'Selected' : card.dataset.kind === 'hat' ? 'Choose Hat' : 'Pick Topper';
      if (lockedHat === card || lockedToppers.has(card)) {
        button.disabled = true;
        button.setAttribute('aria-label', `${card.dataset.productTitle} is included in this starter kit`);
      }
    };

    const update = () => {
      const missingRequiredToppers = [...lockedToppers].filter((card) => !selected.toppers.includes(card));
      const complete = Boolean(selected.hat) && selected.toppers.length >= topperMinimum && missingRequiredToppers.length === 0;
      const chosenCards = [selected.hat, ...selected.toppers].filter(Boolean);
      checkout.disabled = !complete;
      status.textContent = complete ? `Your kit is ready: one hat and ${selected.toppers.length} ${topperLabel(selected.toppers.length)}.` : `${selected.hat ? 'Hat selected' : 'Choose one hat'} · ${selected.toppers.length}/${topperMinimum} ${topperLabel(topperMinimum)} minimum`;
      selections.replaceChildren(...chosenCards.map((card) => {
        const variant = variantData(card);
        const item = document.createElement('li');
        item.className = 'tt-builder-selection';
        const media = variant.image ? Object.assign(document.createElement('img'), { src: variant.image, alt: '' }) : Object.assign(document.createElement('span'), { className: 'tt-builder-selection__image' });
        const copy = document.createElement('div');
        const name = document.createElement('strong');
        name.textContent = card.dataset.productTitle;
        const detail = document.createElement('small');
        detail.textContent = `${card.dataset.kind === 'hat' && variant.title !== 'Default Title' ? `${variant.title} · ` : ''}${formatMoney(variant.price)}`;
        copy.append(name, detail);
        if (lockedHat === card || lockedToppers.has(card)) {
          const included = document.createElement('small');
          included.textContent = 'Included in kit';
          copy.append(included);
          item.append(media, copy);
          return item;
        }
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'tt-builder-selection__remove';
        remove.textContent = '×';
        remove.setAttribute('title', `Remove ${card.dataset.productTitle}`);
        remove.setAttribute('aria-label', `Remove ${card.dataset.productTitle} from your starter kit`);
        remove.addEventListener('click', () => {
          if (card.dataset.kind === 'hat') selected.hat = null;
          else selected.toppers = selected.toppers.filter((entry) => entry !== card);
          setCardState(card, false);
          update();
          card.querySelector('[data-tt-select]')?.focus();
        });
        item.append(media, copy, remove);
        return item;
      }));
      const subtotalCents = chosenCards.reduce((sum, card) => sum + variantData(card).price, 0);
      subtotal.hidden = chosenCards.length === 0;
      total.textContent = formatMoney(subtotalCents);
      const discountCents = complete ? estimatedDiscountCents(subtotalCents) : 0;
      const showEstimate = complete && discountCents > 0;
      const configuredDiscount = Boolean(summary.dataset.couponCode.trim()) &&
        ['percentage', 'fixed_amount'].includes(summary.dataset.estimatedDiscountType) &&
        Number(summary.dataset.estimatedDiscountValue) > 0;
      const missing = [];
      if (!selected.hat) missing.push('Add a hat');
      missingRequiredToppers.forEach((card) => missing.push(`Add ${card.dataset.productTitle}`));
      const additionalToppers = Math.max(0, topperMinimum - selected.toppers.length - missingRequiredToppers.length);
      if (additionalToppers) missing.push(`Add ${additionalToppers} more ${topperLabel(additionalToppers).toLowerCase()}`);
      const showRequirements = configuredDiscount && !complete;
      estimatedDiscount.hidden = !showEstimate && !showRequirements;
      discountLabel.textContent = showRequirements
        ? missing.length === 1 ? `${missing[0]} to unlock savings.` : 'Complete your kit to unlock savings.'
        : 'Estimated discount';
      discountHelp.hidden = !showEstimate;
      discountRequirements.hidden = !showRequirements || missing.length < 2;
      discountRequirementsList.replaceChildren(...missing.map((requirement) => {
        const item = document.createElement('li');
        item.textContent = requirement;
        return item;
      }));
      if (discountRequirements.hidden) discountRequirements.open = false;
      estimatedTotal.hidden = !showEstimate;
      estimatedDiscountAmount.textContent = showEstimate ? `−${formatMoney(discountCents)}` : '';
      estimatedTotalAmount.textContent = showEstimate ? formatMoney(subtotalCents - discountCents) : '';
      error.hidden = true;
      reviewCart.hidden = true;
      bundleId = null;
    };

    cards.forEach((card) => card.querySelector('[data-tt-select]')?.addEventListener('click', () => {
      if (card.dataset.kind === 'hat') {
        if (lockedHat) return;
        if (selected.hat) setCardState(selected.hat, false);
        selected.hat = card;
        setCardState(card, true);
      } else if (lockedToppers.has(card)) {
        return;
      } else if (selected.toppers.includes(card)) {
        selected.toppers = selected.toppers.filter((item) => item !== card);
        setCardState(card, false);
      } else {
        selected.toppers.push(card);
        setCardState(card, true);
      }
      update();
    }));

    cards.forEach((card) => card.querySelectorAll('input[type="radio"][data-tt-variant]').forEach((input) => input.addEventListener('change', () => {
      const variant = variantData(card);
      const productImage = card.querySelector('[data-tt-product-image]') || card.querySelector('.tt-campaign-product-card__media img');
      const selectButton = card.querySelector('[data-tt-select]');
      if (variant.image && productImage) {
        card.dataset.productImage = variant.image;
        productImage.removeAttribute('srcset');
        productImage.removeAttribute('sizes');
        productImage.setAttribute('src', variant.image);
      }
      selectButton.disabled = input.dataset.available !== 'true' || lockedHat === card;
      if (selected.hat === card) update();
    })));

    checkout?.addEventListener('click', async () => {
      if (submitting || !selected.hat || selected.toppers.length < topperMinimum) return;
      submitting = true;
      const isRetry = Boolean(bundleId);
      bundleId ||= createBundleId();
      const expectedTopperCount = selected.toppers.length;
      const items = [selected.hat, ...selected.toppers].map((card, index) => ({ id: variantData(card).id, quantity: 1, properties: { '_Starter Kit Campaign': document.title, '_Starter Kit ID': bundleId, '_Starter Kit Role': index === 0 ? 'hat' : `topper-${index}` } }));
      checkout.disabled = true;
      checkout.textContent = 'Adding kit…';
      error.hidden = true;
      reviewCart.hidden = true;
      try {
        if (isRetry) {
          const existing = await reconcileBundle(bundleId, expectedTopperCount);
          if (existing.complete) {
            await finishAdd();
            return;
          }
          if (existing.partial) throw new Error('Part of this kit is already in your cart.');
        }
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Your kit could not be added.');
        const confirmed = bundleState(result.items, bundleId, expectedTopperCount);
        if (!confirmed.complete) throw new Error('Shopify did not return the complete starter kit after adding it.');
        updateRenderedCart(result);
        await finishAdd();
      } catch (caught) {
        try {
          const reconciled = await reconcileBundleWithRetry(bundleId, expectedTopperCount);
          if (reconciled.complete) {
            await finishAdd();
            return;
          }
          if (reconciled.partial) {
            error.textContent = 'Part of this kit may be in your cart. Review the cart before trying again.';
            reviewCart.hidden = false;
            checkout.disabled = true;
          } else {
            error.textContent = caught.message || 'Your kit could not be added. Your selections are saved; please try again.';
            checkout.disabled = false;
          }
        } catch {
          error.textContent = 'We could not confirm whether the kit was added. Review your cart before trying again.';
          reviewCart.hidden = false;
          checkout.disabled = true;
        }
        error.hidden = false;
        checkout.textContent = 'Add to cart';
        submitting = false;
      }
    });

    if (preselectedHat) {
      selected.hat = preselectedHat;
      setCardState(preselectedHat, true);
    }

    topperCards.filter((card) => card.dataset.preselectedTopper === 'true')
      .forEach((card) => {
        selected.toppers.push(card);
        setCardState(card, true);
      });

    update();
  };
  const initializeAll = (root = document) => root.querySelectorAll('[data-tt-builder]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
